import {
  LOGOUT_FAILED,
  LOGOUT_SUCCESS,
  LOGOUT_INVALID_REQUEST,
  NETWORK_ERROR_LOGOUT,
  RESET_LOGOUT,
  LOADING_LOGOUT,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  invalidRequest: false,
  success: false,
  networkError: "",
  data: {},
  status: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_LOGOUT:
      return {
        ...state,
        isLoading: true,
        failed: false,
        invalidRequest: false,
        success: false,
        networkError: "",
        data: {},
        status: "",
      };

    case LOGOUT_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: true,
        networkError: "",
        data: action.payload,
        status: "Logout Failed!",
      };

    case LOGOUT_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        failed: false,
        networkError: "",
        data: action.payload,
        status: "Oops!, Something went wrong",
      };

    case LOGOUT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        networkError: "",
        data: action.payload,
        status: "",
      };

    case NETWORK_ERROR_LOGOUT:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        invalidRequest: false,
        networkError: "Something went wrong..",
      };

    case RESET_LOGOUT:
      return (state = initialState);

    default:
      return state;
  }
};
